import { render, staticRenderFns } from "./vacantes.vue?vue&type=template&id=04254da2&scoped=true&"
import script from "./vacantes.vue?vue&type=script&lang=js&"
export * from "./vacantes.vue?vue&type=script&lang=js&"
import style0 from "./vacantes.vue?vue&type=style&index=0&id=04254da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04254da2",
  null
  
)

export default component.exports